import React from 'react';
import {connect} from 'react-redux';
import {FilterByGames as BaseFilterByGames} from 'components/organisms/filter-by-games';

class FilterByGames extends BaseFilterByGames {
    canComponentBeRendered() {
        const {sportConfig, lateswapCsvLineups} = this.props;

        return sportConfig.isReady() && sportConfig.useGameFilter() && lateswapCsvLineups.isLoadingStatusFinished();
    }
}

function mapStatesToProps(state) {
    const {
        playersData: {games},
        sportConfig,
        teamsInfo,
        lateSwap: {csvLineups},
    } = state;

    return {
        sportConfig,
        games,
        teamsInfo,
        lateswapCsvLineups: csvLineups,
    };
}

export default connect(mapStatesToProps)(FilterByGames);
